import { BaseResource } from '../core/base-resource';

export class OrderableIngredientGroup extends BaseResource {
  readonly choiceGroup: string;
  readonly ingredients: string[];
}
